import React from 'react';
import '../assets/Css/portfolio.css';
import profile from '../assets/Images/profile.jpg';
import iitklogo from '../assets/Images/iitklogo.jpeg';

const Portfolio = () => {
  return (
    <div>
      <header className="header-background">
        <div className="intro">
          <h1>Shreyaans Jain</h1>
          <hr className="hr" />
          <p>Full Stack Web Developer</p>
        </div>
        <a href="#content">
          <div className="arrow">
            <div className="up"></div>
          </div>
        </a>
      </header>

      <nav className="nav">
        <ul>
          <li>
            <a href="#content">Profile</a>
          </li>
          <li>
            <a href="#abilities">Skills</a>
          </li>
          <li>
            <a href="#projects">Projects</a>
          </li>
          <li>
            <a href="#contact">Contact</a>
          </li>
        </ul>
      </nav>
      <div className="social">
        <a href="https://twitter.com/shreyaansjain06" target="blank">
          Twitter <i className="fa fa-twitter twitter"></i>
        </a>
        <a href="https://www.linkedin.com/in/shreyaansjain06/" target="blank">
          Linkedin <i className="fa fa-linkedin linkedin"></i>
        </a>
        <a href="https://github.com/shreyaansjain06" target="blank">
          Github <i className="fa fa-github github"></i>
        </a>
      </div>
      <section className="content" id="content">
        <p className="header-size">Profile</p>
        <p className="description">I am a Full Stack Web Developer</p>
        <hr className="hr" />
        <div className="adjust">
          <section className="crop">
            <img src={profile} alt="profile" />
          </section>
          <section className="details">
            <p className="header-size-sm">Details</p>
            <div className="description mx-width-17">
             <ul>
               <li><b>Name:</b></li>
               <li>Shreyaans Jain</li>
               <li><b>Age:</b></li>
               <li>18 years</li>
               <li><b>Location:</b></li>
               <li>Panipat,Haryana,India</li>
               <li><b>College:</b></li>
               <li><img src={iitklogo} alt="logo"/>Indian Institute of Technology Kanpur</li>
             </ul>
            </div>
            <div>
            <p className="header-size-sm">About Me</p>
            <p className="about"> Full stack web developer in <b>MERN</b> stack. Loves to learn about new Tech. Open Source Enthusiast. Focus on solving real life problem through tech.
             I love spending time and googling to find solution for bug at which i am stuck. Also I like working in team, learning from each of them, also you will learn faster.
             Belive in learning coding by builidng projects</p>
       </div>
          </section>
        </div>
      </section>
      <section className="abilities" id="abilities">
        <p className="header-size">Skills</p>
        <p className="description">"Once you stop learning, you start dying"</p>
        <p className="description">-Albert Einstien</p>
        <hr className="hr" />
        <div className="adjust">
          <p className="icons">
            <a href="https://getbootstrap.com" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain-wordmark.svg"
                alt="bootstrap"
              />
            </a>
            <a href="https://www.cprogramming.com/" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg"
                alt="c"
              />
            </a>
            <a href="https://www.w3schools.com/cpp/" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg"
                alt="cplusplus"
              />
            </a>
            <a href="https://www.w3schools.com/css/" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg"
                alt="css3"
              />
            </a>
            <a href="https://expressjs.com" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg"
                alt="express"
              />
            </a>
            <a href="https://git-scm.com/" target="blank">
              <img
                src="https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg"
                alt="git"
              />
            </a>
            <a href="https://heroku.com" target="blank">
              <img
                src="https://www.vectorlogo.zone/logos/heroku/heroku-icon.svg"
                alt="heroku"
              />
            </a>
            <a href="https://www.w3.org/html/" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg"
                alt="html5"
              />
            </a>
            <a
              href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
              target="blank"
            >
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg"
                alt="javascript"
              />
            </a>
            <a href="https://www.linux.org/" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg"
                alt="linux"
              />
            </a>
            <a href="https://www.mongodb.com/" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg"
                alt="mongodb"
              />
            </a>
            <a href="https://www.mysql.com/" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg"
                alt="mysql"
              />
            </a>
            <a href="https://nodejs.org" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg"
                alt="nodejs"
              />
            </a>
            <a href="https://www.python.org" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg"
                alt="python"
              />
            </a>
            <a href="https://reactjs.org/" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg"
                alt="react"
              />
            </a>
            <a href="https://redux.js.org" target="blank">
              <img
                src="https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg"
                alt="redux"
              />
            </a>
          </p>
        </div>
      </section>
      <section className="projects" id="projects">
        <p className="header-size">Projects</p>
        <p className="description">
          "If I had asked people what they wanted, they would have said faster
          horses. "
        </p>
        <p className="description">– John Johnson</p>
        <hr className="hr" />

        <div className="center">
          <div className="property-card">
            <a href="https://shreyaansjain06.github.io/food4need/">
              <div className="property-image gd"></div>
            </a>
            <div className="property-description">
              <h5> Food4Need </h5>
              <p>A new apporach to save wastage of food</p>
            </div>
          </div>

          <div className="property-card">
            <a href="https://github.com/shreyaansjain06/Note-Making">
              <div className="property-image note"></div>
            </a>
            <div className="property-description">
              <h5>Note-Making</h5>
              <p>A place to make, edit, store or update notes</p>
            </div>
          </div>

          <div className="property-card">
            <a href="https://react-form-to-pdf-convertor.vercel.app/">
              <div className="property-image form-pdf"></div>
            </a>
            <div className="property-description">
              <h5> React form-to-pdf </h5>
              <p>A simple tool that convert react form to pdf</p>
            </div>
          </div>
        </div>
      </section>
      <section className="contact" id="contact">
        <p className="header-size">Contact</p>
        <p className="description">"Once you stop learning, you start dying"</p>
        <p className="description">- Henry Ford</p>

        <p className="ls-line">Made with ❤️ Shreyaans Jain</p>
      </section>
    </div>
  );
};
export default Portfolio;
